module.exports = __webpack_public_path__ + "static/portfolio2-3b039cb421e17a05c59f10913c2d83f3.jpg";